import { ComponentUtil } from '../../utils/ComponentUtil';
import { Hooks } from '../../types/Hooks';

ComponentUtil.loader(
  !!document.querySelector(Hooks.ImageSlider),
  () => import('./ImageSlider'),
  (ImageSlider) => {
    ComponentUtil.binder(Hooks.ImageSlider, ImageSlider);
  },
);
